import React from 'react';
import { useFontSize } from '../context/FontSizeContext';

const FontSizeControl = () => {
    const { sizeKey, setSizeKey, SIZES } = useFontSize();

    return (
        <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            padding: '4px 8px',
            backgroundColor: '#f9fafb',
            borderRadius: '20px',
            border: '1px solid #e5e7eb',
        }}>
            {/* Ícone */}
            <span style={{ fontSize: `calc(11px * var(--font-scale))`, color: '#9ca3af', userSelect: 'none' }}>
                A
            </span>

            {/* Botões de tamanho */}
            {SIZES.map((size, index) => (
                <button
                    key={size.key}
                    onClick={() => setSizeKey(size.key)}
                    title={size.label}
                    style={{
                        width: '24px',
                        height: '24px',
                        borderRadius: '50%',
                        border: 'none',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: sizeKey === size.key ? '#2563eb' : 'transparent',
                        color: sizeKey === size.key ? '#fff' : '#6b7280',
                        fontSize: `${10 + index * 2}px`,
                        fontWeight: sizeKey === size.key ? '700' : '400',
                        transition: 'all 0.15s',
                    }}
                    onMouseEnter={e => {
                        if (sizeKey !== size.key)
                            e.currentTarget.style.backgroundColor = '#f3f4f6';
                    }}
                    onMouseLeave={e => {
                        if (sizeKey !== size.key)
                            e.currentTarget.style.backgroundColor = 'transparent';
                    }}
                >
                    A
                </button>
            ))}

            {/* Ícone grande */}
            <span style={{ fontSize: '16px', color: '#9ca3af', userSelect: 'none' }}>
                A
            </span>
        </div>
    );
};

export default FontSizeControl;
